
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TooltipElement from '@components/new-styleguide/TooltipElement.vue';

@Component({
  name: 'MaintenanceField',
  components: {
    TooltipElement
  }
})
export default class MaintenanceField extends Vue {
  @Prop({ required: true })
  private id: string;

  @Prop()
  private label: string;

  @Prop()
  private labelTooltip: string;
}
